import { Component } from '@angular/core';
import { DataService } from '../data.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-event-detail',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './event-detail.component.html',
  styleUrl: './event-detail.component.scss'
})
export class EventDetailComponent {
  selectedEvent: any = {};
  eventData: any = []
  id: any;
  xrHvSearch: string = '';

  constructor(private dataService: DataService, private route: ActivatedRoute, private router: Router) {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id') || '';  // Get the 'id' parameter from the route
    });
    this.getEvents();
  }
  sortingData(event: MouseEvent, column: any, type: any) {
    var isAscOrDesc = this.changeSorting(column, type);
    var key;
    if (type === "zone") {
      key = 'get_cp_zone_details';
    } else if (type === "xr-hv-code") {
      key = 'get_xr_hv_code_details';
    } else {
      key = 'get_' + type + '_activity_details';
    }
    var sortData = this.eventData[key];
    isAscOrDesc = isAscOrDesc ? 'asc' : 'desc';
    this.eventData[key] = this.sortByColumn(sortData, column, isAscOrDesc);
  }
  sortByColumn(array: any[], column: string, order: string = 'asc'): any[] {
    return array.sort((a, b) => {
      if (a[column] < b[column]) { return order === 'asc' ? -1 : 1; }
      if (a[column] > b[column]) { return order === 'asc' ? 1 : -1; }
      return 0;
    });
  }
  sortingType: any = {}
  changeSorting(colum: any, type: any) {
    var test = colum + '_' + type
    if (!this.sortingType.hasOwnProperty(test)) {
      this.sortingType[test] = true
    } else {
      this.sortingType[test] = !this.sortingType[test]
    }
    return this.sortingType[test];
  }
  isTransformed(colum: any, type: any) {
    var test = colum + '_' + type
    if (!this.sortingType.hasOwnProperty(test)) {
      this.sortingType[test] = true
    }
    return this.sortingType[test];
  }
  getAttendanceColor(percent: number): string {
    if (!percent) {
      return 'text-red-glow';
    }
    if (percent < 30) {
      return 'text-red-glow';
    } else if (percent < 60) {
      return 'text-orange-glow';
    } else {
      return 'text-green-glow';
    }
  }

  get filteredXrHvData() {
    const data = this.eventData?.get_xr_hv_code_details || [];
    const term = this.xrHvSearch?.toLowerCase().trim();
    if (!term) return data;
    return data.filter((item: any) =>
      item.XR_HV_Code?.toLowerCase().includes(term) ||
      item.Sourcing_Manager_Name?.toLowerCase().includes(term) ||
      item.Type?.toLowerCase().includes(term) ||
      (term === 'in base' && item.Type === 'pre-register') ||
      (term === 'onspot' && item.Type === 'onspot')
    );
  }

  loading = false
  selectEvent(event: any) {
    this.loading = true;
    this.selectedEvent = event;
    this.dataService.fetchEventData(event['event_id']).subscribe(
      (d: any) => {
        this.loading = false;
        console.log("event details", d.data);
        this.eventData = [];
        if (d.data) {
          this.eventData = d.data;
          // Flatten get_xr_hv_code_details if it's an array of arrays
          let xrhv = this.eventData['get_xr_hv_code_details'];
          if (Array.isArray(xrhv)) {
            if (Array.isArray(xrhv[0])) {
              xrhv = xrhv.flat();
            }
          }
          // Fallback: ensure always an array
          if (!Array.isArray(xrhv)) {
            xrhv = [];
          }
          this.eventData['get_xr_hv_code_details'] = xrhv;
          console.log('XR/HV Code Details:', xrhv);
        }
      });
  }
  events: any = []
  findEventById(events: any[], id: number) {
    return events.find(event => event.event_id == id);
  }
  redirectTo() {
    this.router.navigate(['/']);  // Redirects to 'item/123'
  }
  getEvents() {
    this.dataService.fetchEvents().subscribe(
      (d: any) => {
        console.log(d.data)
        if (d.data) {
          // d.data['get_cp_zone_details'] = null
          this.events = d.data
          console.log(d.data)
          var event = this.findEventById(d.data, this.id)
          if (event != null) {
            this.selectEvent(event);
          }
        }
      });
  }
}
